import { render, staticRenderFns } from "./registration.vue?vue&type=template&id=37e62dce&scoped=true&"
import script from "./registration.vue?vue&type=script&lang=js&"
export * from "./registration.vue?vue&type=script&lang=js&"
import style0 from "./registration.vue?vue&type=style&index=0&id=37e62dce&scoped=true&lang=scss&"
import style1 from "./registration.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e62dce",
  null
  
)

component.options.__file = "registration.vue"
export default component.exports